import Dexie from "dexie";
import { ICalendarEvent } from "../../domain/calendarEvents/ICalendarEvent";
import { ICalendar } from "../../domain/calendars/ICalendar";

export class LocalDb extends Dexie {
    public calendars: Dexie.Table<ICalendar, string>;
    public events: Dexie.Table<ICalendarEvent, string>;

    public constructor() {
        super("PersonalAssistant");
        this.version(1).stores({
            calendars: "id,name",
            events: "id,calendarId,start,end"
        });
        this.calendars = this.table("calendars");
        this.events = this.table("events");
    }
}

export const localDb = new LocalDb();
